// src/data/exercises/L6_01.js

const accountOptions = [
  '現金', '売掛金', '貸倒引当金', '売上', '貸倒損失'];

export const L6_01 = {
  title: '簿記　3級（第215-1回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
       parts: [
    { "type": "ruby", "text": "当期", "ruby": "とうき" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "生", "ruby": "しょう" },
    { "type": "text", "value": "じた" },
    { "type": "ruby", "text": "富山株式会社", "ruby": "とやまかぶしきがいしゃ" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "対", "ruby": "たい" },
    { "type": "text", "value": "する" },
    { "type": "ruby", "text": "売掛金", "ruby": "うりかけきん" },
    { "type": "text", "value": "￥2,024,000が" },
    { "type": "ruby", "text": "回収不能", "ruby": "かいしゅうふのう" },
    { "type": "text", "value": "となり、その全額を" },
    { "type": "ruby", "text": "貸倒処理", "ruby": "かしだおれしょり" },
    { "type": "text", "value": "した。" }
]

,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '貸倒損失', debitAmount: 2024000, creditAccount: '売掛金', creditAmount: 2024000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '「売掛金￥2,024,000が回収不能」→売掛金がもらえない\n' },
          { type: 'styled', value: '①売掛金が減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'text', value: '「回収不能」→貸倒損失or貸倒引当金を使う\n' },
          { type: 'text', value: '「当期」の場合は「貸倒損失」を使うので\n' },
          { type: 'styled', value: '②貸倒損失が借方（左・Ｄｒ）', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`

「売掛金￥2,024,000が回収不能」→売掛金がもらえない
①売掛金が減少（マイナス）します。

「回収不能」→貸倒損失or貸倒引当金を使う
「当期」の場合は「貸倒損失」を使うので
　②貸倒損失が発生（プラス）します。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '「「売掛金￥2,024,000が回収不能」→売掛金がもらえない\n' },
          { type: 'styled', value: '①売掛金が減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'text', value: '「回収不能」→貸倒損失or貸倒引当金を使う\n' },
          { type: 'text', value: '「当期」の場合は「貸倒損失」を使うので\n' },
          { type: 'styled', value: '②貸倒損失が借方（左・Ｄｒ）', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};